export default [
  {
    path: "/specialActivity",
    component: () => import("@/views/modules/specialActivity/index.vue"),
    name: "specialActivity",
    meta: { title: "主题活动" },
  },
];
